import {
    Link,
    useNavigate
} from "react-router-dom";

const Student = () => {

    const navigate = useNavigate();

    return (
        <div className="std container1">
            <div className="history">
                <i className="fa-solid fa-circle-left" onClick={() => navigate(-1)}></i>
                <i className="fa-solid fa-circle-right" onClick={() => navigate(1)}></i>
            </div>
            <div className=" container-fluid container2">
                <h2 className="page_title" style={{ fontSize: "20px", fontWeight: "bold", marginLeft: "10px", borderBottom: "1px dotted gray" }}>IT Students</h2>
                <ul>
                    <li style={{ marginTop: "5px" }}><Link to="/student/batch_2020"><span className="hover-1">2020 Batch</span></Link></li>
                    <li style={{ marginTop: "5px" }}><Link to="/student/batch_2019"><span className="hover-1">2019 Batch</span></Link></li>
                    <li style={{ marginTop: "5px" }}><a href="/syllabus/2018_student.pdf" target="_blank"><span className="hover-1">2018 Batch</span></a></li>
                    <li style={{ marginTop: "5px" }}><a href="/syllabus/2017_student.pdf" target="_blank"><span className="hover-1">2017 Batch</span></a></li>
                    <li style={{ marginTop: "5px" }}><a href="/syllabus/2016_student.pdf" target="_blank"><span className="hover-1">2016 Batch</span></a></li>
                    <li style={{ marginTop: "5px" }}><a href="/syllabus/2015_student.pdf" target="_blank"><span className="hover-1">2015 Batch</span></a></li>
                </ul>
            </div>
        </div>
    )
}
export default Student